module.exports = __webpack_public_path__ + "img/met-logo.1c473c0f.svg";